import styledTheme from 'common/theme';
import styled from 'styled-components';

export const SiteTableWidgetContainer = styled.div`
  display: flex;
  .site-line-machine-table {
    width: 100%;
  }

  .site-line-machine-table button {
    color: ${styledTheme.colors.Telemetry300};
    text-decoration: underline;
    background: none;
    border: none;
    padding: 0;
    cursor: pointer;
    display: flex;
    gap: 5px;
  }
`;

export const IconContainer = styled.div`
  position: relative;
  display: inline-flex;
  svg {
    width: 16px;
  }
`;

export const CounterItem = styled.div`
  width: 18px;
  height: 18px;
  top: -8px;
  right: -9px;
  background-color: ${styledTheme.colors.caution100};
  color: white;
  border-radius: 50%;
  padding: 2px 3px;
  font-size: 10px;
  line-height: 1.5;
  position: absolute;
`;

export const LineMachineStateIconContainer = styled.div<{ color?: string }>`
  display: grid;
  grid-template-columns: max-content auto;
  gap: 0.3em;
  min-width: max-content;

  .label {
    font-weight: 600;
    text-transform: capitalize;

    color: ${({ color }) => color || 'inherit'};
  }

  .icon {
    width: 1em;
    height: 1em;
  }

  .icon:not(.icon--check-mark-with-circle) path {
    stroke-width: 2;
  }
`;
